import { themeColors } from "../theme/colors";

export const IMPORTANCE_LEVELS = [
  { 
    id: 0, 
    name: "Routine", 
    color: themeColors.black_700, 
    backgroundColor: themeColors.black_100 
  },
  { 
    id: 1, 
    name: "Important", 
    color: themeColors.purpleMedium, 
    backgroundColor: "#5879ED3D" 
  },
  { 
    id: 2, 
    name: "Urgent", 
    color: themeColors.red_700, 
    backgroundColor: themeColors.red_200 
  },
];